"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var indianStates = [{
  name: "Andaman And Nicobar Islands",
  code: "AN"
}, {
  name: "Andhra Pradesh",
  code: "AP"
}, {
  name: "Arunachal Pradesh",
  code: "AR"
}, {
  name: "Assam",
  code: "AS"
}, {
  name: "Bihar",
  code: "BR"
}, {
  name: "Chandigarh",
  code: "CH"
}, {
  name: "Chhattisgarh",
  code: "CT"
}, {
  name: "Delhi",
  code: "DL"
}, {
  name: "GOA",
  code: "GA"
}, {
  name: "Gujarat",
  code: "GJ"
}, {
  name: "Himachal Pradesh",
  code: "HP"
}, {
  name: "Haryana",
  code: "HR"
}, {
  name: "Jharkhand",
  code: "JH"
}, {
  name: "Jammu And Kashmir",
  code: "JK"
}, {
  name: "Karnataka",
  code: "KA"
}, {
  name: "Kerala",
  code: "KL"
}, {
  name: "Lakshadweep",
  code: "LD"
}, {
  name: "Maharashtra",
  code: "MH"
}, {
  name: "Meghalaya",
  code: "ML"
}, {
  name: "Manipur",
  code: "MN"
}, {
  name: "Madhya Pradesh",
  code: "MP"
}, {
  name: "Mizoram",
  code: "MZ"
}, {
  name: "Nagaland",
  code: "NL"
}, {
  name: "Odisha",
  code: "OR"
}, {
  name: "Punjab",
  code: "PB"
}, {
  name: "Puducherry",
  code: "PY"
}, {
  name: "Rajasthan",
  code: "RJ"
}, {
  name: "Sikkim",
  code: "SK"
}, {
  name: "Tamil Nadu",
  code: "TN"
}, {
  name: "Tripura",
  code: "TR"
}, {
  name: "Uttarakhand",
  code: "UT"
}, {
  name: "Uttar Pradesh",
  code: "UP"
}, {
  name: "West Bengal",
  code: "WB"
}, {
  name: "Telangana",
  code: "TG"
}, {
  name: "Ladakh",
  code: "LA"
}, {
  name: "Dadra And Nagar Haveli And Daman And Diu",
  code: "DH"
}];

var getIndiaStates = exports.getIndiaStates = function getIndiaStates() {
  return indianStates.map(function (state) {
    return {
      name: state.name,
      value: state.name,
      code: state.code
    };
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/countryStateCodes.js
// module id = 647
// module chunks = 0